import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

//Multi Select Dropdown
import Multiselect from 'multiselect-react-dropdown';

// action
import {
  getSetting,
  updateSetting,
  handleSwitch,
} from '../store/setting/action';

import { set } from 'date-fns';
import { getRedeemOptions } from '../store/redeemOptions/action';

const Setting = (props) => {
  const { redeemOptions } = useSelector((state) => state.redeemOption);
  
  const dispatch = useDispatch();

  const [mongoId, setMongoId] = useState('');
  const [referralBonus, setReferralBonus] = useState(0);
  const [loginBonus, setLoginBonus] = useState(0);
  const [agoraKey, setAgoraKey] = useState('');
  const [agoraCertificate, setAgoraCertificate] = useState('');
  const [maxSecondForVideo, setMaxSecondForVideo] = useState(0);
  const [privacyPolicyLink, setPrivacyPolicyLink] = useState('');
  const [privacyPolicyText, setPrivacyPolicyText] = useState('');
  // const [chatCharge, setChatCharge] = useState("");
  const [callCharge, setCallCharge] = useState(0);
  const [googlePlayEmail, setGooglePlayEmail] = useState('');
  const [googlePlayKey, setGooglePlayKey] = useState('');
  const [stripePublishableKey, setStripePublishableKey] = useState('');
  const [stripeSecretKey, setStripeSecretKey] = useState('');
  const [currency, setCurrency] = useState('$');
  const [rCoinForCashOut, setRCoinForCashOut] = useState(parseInt(0));
  const [rCoinForDiamond, setRCoinForDiamond] = useState(parseInt(0));

  const [googlePlaySwitch, setGooglePlaySwitch] = useState(false);
  const [stripeSwitch, setStripeSwitch] = useState(false);
  const [isAppActive, setIsAppActive] = useState(false);
  const [isFake, setIsFake] = useState(false);
  const [vipDiamond, setVipDiamond] = useState(0);
  const [resendApiKey, setResendApiKey] = useState('');

  const [femaleCallCharge, setFemaleCallCharge] = useState(0);

  const [femaleRandomCallRate, setFemaleRandomCallRate] = useState(0);
  const [maleRandomCallRate, setMaleRandomCallRate] = useState(0);
  const [bothRandomCallRate, setBothRandomCallRate] = useState(0);

  const [maleCallCharge, setMaleCallCharge] = useState(0);

  const [minRCoinForCaseOut, setMinRCoinForCaseOut] = useState(0);
  const [paymentGateway, setPaymentGateway] = useState([]);
  const [selectedValue, setSelectedValue] = useState([]);
  const [coinSetup, setCoinSetup] = useState('');

  const [privateKey, setPrivateKey] = useState();

  const [errors, setError] = useState({
    referralBonus: '',
    loginBonus: '',
    maxSecondForVideo: '',
    callCharge: '',
    rCoinForCashOut: '',
    rCoinForDiamond: '',
    minRCoinForCaseOut: '',
    vipDiamond: '',
    resendApiKey: '',
    maleCallCharge: '',
    femaleCallCharge: '',
    femaleRandomCallRate: '',
    bothRandomCallRate: '',
    maleRandomCallRate: '',
    privateKey: '',
  });

  useEffect(() => {
    dispatch(getRedeemOptions());
  }, [])

  useEffect(() => {
  }, [dispatch]);

  const setting = useSelector((state) => state.setting.setting);
  console.log('setting', setting);

  useEffect(() => {
    setError({
      vipDiamond: '',
      resendApiKey: '',
      referralBonus: '',
      loginBonus: '',
      maxSecondForVideo: '',
      callCharge: '',
      rCoinForCashOut: '',
      rCoinForDiamond: '',
      minRCoinForCaseOut: '',
      femaleCallCharge: '',
      femaleRandomCallRate: '',
      bothRandomCallRate: '',
      maleRandomCallRate: '',
      maleCallCharge: '',
      privateKey: '',
    });
    if (setting) {
      const data = setting?.paymentGateway?.map((data) => {
        return {
          name: data,
        };
      });
      setMaleCallCharge(setting?.maleCallCharge);
      setFemaleCallCharge(setting?.femaleCallCharge);
      setFemaleRandomCallRate(setting?.femaleRandomCallRate);
      setBothRandomCallRate(setting?.bothRandomCallRate);
      setMaleRandomCallRate(setting?.maleRandomCallRate);
      setMongoId(setting._id);
      setVipDiamond(setting?.vipDiamond);
      setResendApiKey(setting?.resendApiKey);
      setReferralBonus(setting.referralBonus);
      setAgoraKey(setting.agoraKey);
      setAgoraCertificate(setting.agoraCertificate);
      setMaxSecondForVideo(setting.maxSecondForVideo);
      setPrivacyPolicyLink(setting.privacyPolicyLink);
      setPrivacyPolicyText(setting.privacyPolicyText);
      // setChatCharge(setting.chatCharge);
      setCallCharge(setting.callCharge);
      setGooglePlayEmail(setting.googlePlayEmail);
      setGooglePlayKey(setting.googlePlayKey);
      setStripePublishableKey(setting.stripePublishableKey);
      setStripeSecretKey(setting.stripeSecretKey);
      setCurrency(setting.currency);
      setRCoinForCashOut(setting.rCoinForCashOut);
      setRCoinForDiamond(setting.rCoinForDiamond);
      setGooglePlaySwitch(setting.googlePlaySwitch);
      setStripeSwitch(setting.stripeSwitch);
      setIsAppActive(setting.isAppActive);
      setIsFake(setting.isFake);
      setLoginBonus(setting.loginBonus);
      setMinRCoinForCaseOut(setting.minRcoinForCashOut);
      setPaymentGateway(setting.paymentGateway);
      setCoinSetup(setting?.currency?.currencyCode);

      setSelectedValue(data);

      setPrivateKey(JSON.stringify(setting?.privateKey));
    }
  }, [setting]);

  const handleSubmit = () => {

    const referralBonusValid = isNumeric(referralBonus);
    if (!referralBonusValid) {
      return setError({ ...errors, referralBonus: 'Invalid Referral Bonus!!' });
    }
    const loginBonusValid = isNumeric(loginBonus);
    if (!loginBonusValid) {
      return setError({ ...errors, loginBonus: 'Invalid Login Bonus!!' });
    }
    const maxSecondForVideoValid = isNumeric(maxSecondForVideo);
    if (!maxSecondForVideoValid) {
      return setError({
        ...errors,
        maxSecondForVideo: 'Invalid Value!!',
      });
    }

    const femaleCallChargeValid = isNumeric(femaleCallCharge);
    if (!femaleCallChargeValid) {
      return setError({
        ...errors,
        femaleCallCharge: 'Invalid Female  Call Charge!!',
      });
    }
    const femaleRandomCallRateValid = isNumeric(femaleRandomCallRate);
    if (!femaleRandomCallRateValid) {
      return setError({
        ...errors,
        femaleRandomCallRate: 'Invalid Female Random Call Charge!!',
      });
    }
    const maleRandomCallRateValid = isNumeric(maleRandomCallRate);
    if (!maleRandomCallRateValid) {
      return setError({
        ...errors,
        maleRandomCallRate: 'Invalid Female Random Call Charge!!',
      });
    }

    const bothRandomCallRateValid = isNumeric(bothRandomCallRate);
    if (!bothRandomCallRateValid) {
      return setError({
        ...errors,
        bothRandomCallRate: 'Invalid Female Random Call Charge!!',
      });
    }

    const maleCallChargeValid = isNumeric(maleCallCharge);
    if (!maleCallChargeValid) {
      return setError({
        ...errors,
        maleCallCharge: 'Invalid Male Call Charge!!',
      });
    }
    const vipDiamondValid = isNumeric(vipDiamond);
    if (!vipDiamondValid) {
      return setError({
        ...errors,
        vipDiamond: 'Invalid Call Charge!!',
      });
    }
    //  const resendApiKeyValid = isNumeric(resendApiKey);
    // if (!resendApiKeyValid) {
    //   return setError({
    //     ...errors,
    //     resendApiKey: "Invalid Resend Api Key !!",
    //   });
    // }
    const rCoinForCaseOutValid = isNumeric(rCoinForCashOut);
    if (!rCoinForCaseOutValid) {
      return setError({
        ...errors,
        rCoinForCashOut: 'Invalid Value!!',
      });
    }
    const rCoinForDiamondValid = isNumeric(rCoinForDiamond);
    if (!rCoinForDiamondValid) {
      return setError({
        ...errors,
        rCoinForDiamond: 'Invalid Value!!',
      });
    }

    const minRCoinForCaseOutValid = isNumeric(minRCoinForCaseOut);
    if (!minRCoinForCaseOutValid) {
      return setError({
        ...errors,
        minRCoinForCaseOut: 'Invalid Value!!',
      });
    }

    const data = {
      referralBonus,
      loginBonus,
      agoraKey,
      agoraCertificate,
      maxSecondForVideo: maxSecondForVideo === '' ? 0 : maxSecondForVideo,
      privacyPolicyLink,
      privacyPolicyText,
      chatCharge: 0,
      femaleCallCharge: femaleCallCharge === '' ? 0 : femaleCallCharge,
      femaleRandomCallRate:
        femaleRandomCallRate === '' ? 0 : femaleRandomCallRate,
      bothRandomCallRate: bothRandomCallRate === '' ? 0 : bothRandomCallRate,
      maleRandomCallRate: maleRandomCallRate === '' ? 0 : maleRandomCallRate,
      maleCallCharge: maleCallCharge === '' ? 0 : maleCallCharge,
      googlePlayEmail,
      googlePlayKey,
      stripePublishableKey,
      stripeSecretKey,
      currency,
      rCoinForCashOut: rCoinForCashOut === '' ? 0 : rCoinForCashOut,
      rCoinForDiamond: rCoinForDiamond === '' ? 1 : rCoinForDiamond,
      paymentGateway,
      minRcoinForCaseOut: minRCoinForCaseOut,
      vipDiamond,
      resendApiKey,
      privateKey,
    };

    props.updateSetting(mongoId, data);
  };

  const handleSwitch_ = (type) => {

    props.handleSwitch(mongoId, type);
  };

  //onselect function of selecting multiple values
  function onSelect(selectedList, selectedItem) {
    paymentGateway.push(selectedItem.name);
  }

  //onRemove function for remove multiple values
  function onRemove(selectedList, removedItem) {
    setPaymentGateway(selectedList.map((data) => data.name));
  }

  const isNumeric = (value) => {
    const val = value === '' ? 0 : value;
    const validNumber = /^\d+$/.test(val);
    return validNumber;
  };
  
  const option = redeemOptions.map((opt) => ({ name: opt.name }));

  const fakeFirebaseJson = {
    type: 'service_account',
    project_id: 'demo-project-12345',
    private_key_id: 'fakeprivatekeyid1234567890abcdef',
    private_key:
      '-----BEGIN PRIVATE KEY-----\nMIIEvQIBADANBgkqhkiG9w0FAKEFAASCBKcwggSjAgEAAoIBAQDUMMYKEYEXAMPLE\n-----END PRIVATE KEY-----\n',
    client_email:
      'firebase-adminsdk-abcde@demo-project-12345.iam.gserviceaccount.com',
    client_id: '123456789012345678901',
    auth_uri: 'https://accounts.google.com/o/oauth2/auth',
    token_uri: 'https://oauth2.googleapis.com/token',
    auth_provider_x509_cert_url: 'https://www.googleapis.com/oauth2/v1/certs',
    client_x509_cert_url:
      'https://www.googleapis.com/robot/v1/metadata/x509/firebase-adminsdk-abcde%40demo-project-12345.iam.gserviceaccount.com',
    universe_domain: 'googleapis.com',
  };

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">Setting</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Setting
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="row">
        <div class="col-md-6 col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div className="col-md-6 col-12">
                  <h5 class="card-title ">Other Setting</h5>
                </div>
                <div className="col-md-6 col-12 d-flex justify-content-between mb-0">
                  <h5 class="card-title mb-0 me-4">Fake Data</h5>
                  <label class="switch">
                    <input
                      type="checkbox"
                      checked={isFake}
                      onChange={() => handleSwitch_('fake')}
                    />
                    <span class="slider">
                      <p
                        style={{
                          fontSize: 12,
                          marginLeft: `${isFake ? '7px' : '35px'}`,
                          color: `${isFake ? '#fff' : '#000'}`,
                          marginTop: '6px',
                        }}
                      >
                        {isFake ? 'Yes' : 'No'}
                      </p>
                    </span>
                  </label>
                </div>
                <form>
                  <div class="mb-3 row">
                    <div class="col-md-6">
                      <label for="referralBonus" class="form-label">
                        Referral Bonus
                      </label>
                      <input
                        type="number"
                        class="form-control"
                        id="referralBonus"
                        placeholder={'Enter Referral Bonus'  }
                        value={referralBonus}
                        onChange={(e) => setReferralBonus(e.target.value)}
                      />
                      {errors.referralBonus && (
                        <div className="ml-2 mt-1">
                          {errors.referralBonus && (
                            <div className="pl-1 text__left">
                              <span className="text-red">
                                {errors.referralBonus}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div class="col-md-6">
                      <label for="loginBonus" class="form-label">
                        Login Bonus
                      </label>
                      <input
                        type="number"
                        class="form-control"
                        id="loginBonus"
                        placeholder={ 'Enter Login Bonus'  }
                        value={loginBonus}
                        onChange={(e) => setLoginBonus(e.target.value)}
                      />
                      {errors.loginBonus && (
                        <div className="ml-2 mt-1">
                          {errors.loginBonus && (
                            <div className="pl-1 text__left">
                              <span className="text-red">
                                {errors.loginBonus}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div class="mb-3">
                    {/* <label for="videoSecond" class="form-label">
                      Maximum Seconds for Video
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      id="videoSecond"
                      value={maxSecondForVideo}
                      onChange={(e) => setMaxSecondForVideo(e.target.value)}
                    />
                    {errors.maxSecondForVideo && (
                      <div className="ml-2 mt-1">
                        {errors.maxSecondForVideo && (
                          <div className="pl-1 text__left">
                            <span className="text-red">
                              {errors.maxSecondForVideo}
                            </span>
                          </div>
                        )}
                      </div>
                    )} */}
                  </div>
                  <div
                    className="d-flex justify-content-end"
                    style={{ marginTop: '50px' }}
                  >
                    <button
                      type="button"
                      class="btn btn-danger "
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <h5 class="card-title d-flex justify-content-between mb-3">
                  Is App Active (use at the time of app maintenance)
                  <label class="switch">
                    <input
                      type="checkbox"
                      checked={isAppActive}
                      onChange={() => handleSwitch_('app active')}
                    />
                    <span class="slider">
                      <p
                        style={{
                          fontSize: 12,
                          marginLeft: `${isAppActive ? '7px' : '35px'}`,
                          color: `${isAppActive ? '#fff' : '#000'}`,
                          marginTop: '6px',
                        }}
                      >
                        {isAppActive ? 'Yes' : 'No'}
                      </p>
                    </span>
                  </label>
                </h5>

                <form>
                  <div class="mb-3">
                    <label for="policyLink" class="form-label">
                      Privacy Policy Link (redirect to this link in app in
                      privacy policy click)
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="policyLink"
                      placeholder={'Enter Privacy Policy Link'  }
                      value={privacyPolicyLink}
                      onChange={(e) => setPrivacyPolicyLink(e.target.value)}
                    />
                  </div>
                  <div class="mb-3">
                    <label for="policyText" class="form-label">
                      Privacy Policy Text
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="policyText"
                      placeholder={ 'Enter Privacy Policy Text' }
                      value={privacyPolicyText}
                      onChange={(e) => setPrivacyPolicyText(e.target.value)}
                    />
                  </div>
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      class="btn btn-danger "
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h3 className="mb-3 text-white">Coin Setting</h3>
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <h5 class="card-title ">Private Call Charges</h5>

                <form>
                  <div class="mb-3 row">
                    <div class="col-md-12">
                      <label for="femaleCallCHarge" class="form-label">
                        Female Call Charge (per min for user)
                      </label>
                      <input
                        type="number"
                        class="form-control"
                        id="referralBonus"
                        placeholder={ 'Enter Female Call Charge'  }
                        value={femaleCallCharge}
                        onChange={(e) => setFemaleCallCharge(e.target.value)}
                      />
                      {errors.femaleCallCharge && (
                        <div className="ml-2 mt-1">
                          {errors.femaleCallCharge && (
                            <div className="pl-1 text__left">
                              <span className="text-red">
                                {errors.femaleCallCharge}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div class="col-md-12">
                      <label for="maleCoinCharge" class="form-label">
                        Male Call Charge (per min for user)
                      </label>
                      <input
                        type="number"
                        class="form-control"
                        id="maleCallCharge"
                        placeholder={ 'Enter Male Call Charge'}
                        value={maleCallCharge}
                        onChange={(e) => setMaleCallCharge(e.target.value)}
                      />
                      {errors.maleCallCharge && (
                        <div className="ml-2 mt-1">
                          {errors.maleCallCharge && (
                            <div className="pl-1 text__left">
                              <span className="text-red">
                                {errors.maleCallCharge}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <h5 class="card-title" style={{ marginTop: '28px' }}>
                    Random Call Charges
                  </h5>

                  <div class="mb-3 row">
                    <div class="col-md-12">
                      <label for="femaleRandomCallRate" class="form-label">
                        Female Random Call Charge per min
                      </label>
                      <input
                        type="number"
                        class="form-control"
                        id="femaleRandomCallRate"
                        placeholder={'Enter Female Call Charge'  }
                        value={femaleRandomCallRate}
                        onChange={(e) =>
                          setFemaleRandomCallRate(e.target.value)
                        }
                      />
                      {errors.femaleRandomCallRate && (
                        <div className="ml-2 mt-1">
                          {errors.femaleRandomCallRate && (
                            <div className="pl-1 text__left">
                              <span className="text-red">
                                {errors.femaleRandomCallRate}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div class="col-md-12">
                      <label for="maleCoinCharge" class="form-label">
                        Male Random Call Charge per min
                      </label>
                      <input
                        type="number"
                        class="form-control"
                        id="maleRandomCallRate"
                        placeholder={ 'Enter Male Call Charge' }
                        value={maleRandomCallRate}
                        onChange={(e) => setMaleRandomCallRate(e.target.value)}
                      />
                      {errors.maleRandomCallRate && (
                        <div className="ml-2 mt-1">
                          {errors.maleRandomCallRate && (
                            <div className="pl-1 text__left">
                              <span className="text-red">
                                {errors.maleRandomCallRate}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    <div class="col-md-12">
                      <label for="bothRandomCallRate" class="form-label">
                        Both Random Call Charge per min
                      </label>
                      <input
                        type="number"
                        class="form-control"
                        id="bothRandomCallRate"
                        placeholder={ 'Enter Random Call Charge' }
                        value={bothRandomCallRate}
                        onChange={(e) => setBothRandomCallRate(e.target.value)}
                      />
                      {errors.bothRandomCallRate && (
                        <div className="ml-2 mt-1">
                          {errors.bothRandomCallRate && (
                            <div className="pl-1 text__left">
                              <span className="text-red">
                                {errors.bothRandomCallRate}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    className="d-flex justify-content-end"
                    style={{ marginTop: '26px' }}
                  >
                    <button
                      type="button"
                      class="btn btn-danger "
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Coin Setup</h5>
              <form>
                <div class="mb-3 row">
                  <div className="col-5">
                    <label for="rCoin" class="form-label">
                      RCoin Rate (for cash out conversion ratio)
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="rCoin"
                      placeholder={'1 Dollar'}
                      value={`1 Dollar`}
                   
                      disabled
                    />
                  </div>
                  <div className="col-1 mt-5">=</div>
                  <div className="col-6">
                    <label for="rCoin" class="form-label">
                      How Many RCoin
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      id="rCoin"
                      placeholder={ 'Enter RCoin'}
                      value={rCoinForCashOut}
                      onChange={(e) =>
                        setRCoinForCashOut(parseInt(e.target.value))
                      }
                    />
                    {errors.rCoinForCashOut && (
                      <div className="ml-2 mt-1">
                        {errors.rCoinForCashOut && (
                          <div className="pl-1 text__left">
                            <span className="text-red">
                              {errors.rCoinForCashOut}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div class="mb-3 row">
                  <div className="col-5">
                    <label for="rCoin" class="form-label">
                      Diamond
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="rCoin"
                      value="1 Diamond"
                      disabled
                    />
                  </div>
                  <div className="col-1 mt-5">=</div>
                  <div className="col-6">
                    <label for="rCoin" class="form-label">
                      How Many RCoin ( Diamond to Rcoin conversion ratio )
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      id="rCoin"
                      placeholder={'Enter RCoin' }
                      value={rCoinForDiamond}
                      onChange={(e) =>
                        setRCoinForDiamond(parseInt(e.target.value))
                      }
                    />
                    {errors.rCoinForDiamond && (
                      <div className="ml-2 mt-1">
                        {errors.rCoinForDiamond && (
                          <div className="pl-1 text__left">
                            <span className="text-red">
                              {errors.rCoinForDiamond}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </form>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  class="btn btn-danger mt-5"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <h3 className="mb-3 text-white">Agora Setting</h3>
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <form>
                      <div class="mb-3">
                        <label for="googlePlayEmail" class="form-label">
                          Agora Key
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="googlePlayEmail"
                          placeholder={'Enter Agora Key' }
                          value={agoraKey}
                          onChange={(e) => setAgoraKey(e.target.value)}
                        />
                      </div>
                      <div class="mb-3">
                        <label for="key" class="form-label">
                          Agora Certificates
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="key"
                          placeholder={'Enter Agora Certificates' }
                          value={agoraCertificate}
                          onChange={(e) => setAgoraCertificate(e.target.value)}
                        />
                      </div>
                      <div className="d-flex justify-content-end">
                        <button
                          type="button"
                          class="btn btn-danger "
                          onClick={handleSubmit}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <h3 className="mb-3 text-white">Redeem Setting</h3>
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <form>
                      <div class="mb-3">
                        <label for="googlePlayEmail" class="form-label">
                          Payment Gateway
                        </label>
                        <Multiselect
                          options={option}
                          selectedValues={selectedValue}
                          onSelect={onSelect}
                          onRemove={onRemove}
                          displayValue="name"
                        />
                      </div>

                      <div class="mb-3">
                        <label for="minRCoinForCaseOut" class="form-label">
                          Minimum RCoin for cash out
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          id="minRCoinForCaseOut"
                          placeholder={ 'Enter RCoin'}
                          value={minRCoinForCaseOut}
                          onChange={(e) =>
                            setMinRCoinForCaseOut(parseInt(e.target.value))
                          }
                        />
                        {errors.minRCoinForCaseOut && (
                          <div className="ml-2 mt-1">
                            {errors.minRCoinForCaseOut && (
                              <div className="pl-1 text__left">
                                <span className="text-red">
                                  {errors.minRCoinForCaseOut}
                                </span>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="d-flex justify-content-end">
                        <button
                          type="button"
                          class="btn btn-danger "
                          onClick={handleSubmit}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <h3 className="mb-3 text-white">Payment Setting</h3>
          <div class="row">
            <div class=" col-12">
              <div class="card">
                <div class="card-body">
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <h5 class="card-title d-flex justify-content-between align-items-center">
                        Stripe (enable/disable in app)
                        <label class="switch">
                          <input
                            type="checkbox"
                            checked={stripeSwitch}
                            onChange={() => handleSwitch_('stripe')}
                          />
                          <span class="slider">
                            <p
                              style={{
                                fontSize: 12,
                                marginLeft: `${stripeSwitch ? '7px' : '35px'}`,
                                color: `${stripeSwitch ? '#fff' : '#000'}`,
                                marginTop: '6px',
                              }}
                            >
                              {stripeSwitch ? 'Yes' : 'No'}
                            </p>
                          </span>
                        </label>
                      </h5>
                    </div>
                    <div className="col-md-6 col-12">
                      <h5 class="card-title d-flex justify-content-between align-items-center">
                        Google Play (enable/disable)
                        <label class="switch">
                          <input
                            type="checkbox"
                            checked={googlePlaySwitch}
                            onChange={() => handleSwitch_('googlePlay')}
                          />
                          <span class="slider">
                            <p
                              style={{
                                fontSize: 12,
                                marginLeft: `${googlePlaySwitch ? '7px' : '35px'
                                  }`,
                                color: `${googlePlaySwitch ? '#fff' : '#000'}`,
                                marginTop: '6px',
                              }}
                            >
                              {googlePlaySwitch ? 'Yes' : 'No'}
                            </p>
                          </span>
                        </label>
                      </h5>
                    </div>
                  </div>
                  <form>
                    <div class="mb-3">
                      <label for="publishableKey" class="form-label">
                        Stripe Publishable Key
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="publishableKey"
                        placeholder={` Stripe Publishable Key`  }
                        value={stripePublishableKey}
                        onChange={(e) =>
                          setStripePublishableKey(e.target.value)
                        }
                      />
                    </div>
                    <div class="mb-3">
                      <label for="secretKey" class="form-label">
                        Stripe Secret Key
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="secretKey"
                        placeholder={`Stripe Secret Key`  }
                        value={stripeSecretKey}
                        onChange={(e) => setStripeSecretKey(e.target.value)}
                      />
                    </div>
                  </form>
                  <div
                    className="d-flex justify-content-end"
                    style={{ marginTop: '63px' }}
                  >
                    <button
                      type="button"
                      class="btn btn-danger "
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <h3 className="mb-3 text-white">Firebase Notification Setting</h3>
          <div class="row">
            <div class=" col-12">
              <div class="card">
                <div class="card-body">
                  <form>
                    <div className="">
                      <label class="form-label" htmlFor="privateKey">
                        Private Key JSON ( use for firebase push notification)
                      </label>
                      <textarea
                        name=""
                        className="form-control mt-2"
                        id="privateKey"
                        placeholder={`Enter firebaseKey` }
                        rows={10}
                        value={privateKey}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          try {
                            const newData = JSON.parse(newValue);
                            setPrivateKey(newValue);
                            setError('');
                          } catch (error) {
                            // Handle invalid JSON input
                            console.error('Invalid JSON input:', error);
                            setPrivateKey(newValue);
                            return setError({
                              ...error,
                              privateKey: 'Invalid JSON input',
                            });
                          }
                        }}
                      ></textarea>

                      {errors.privateKey && (
                        <div className="ml-2 mt-1">
                          {errors.privateKey && (
                            <div className="pl-1 text__left">
                              <span className="text-red">
                                {errors.privateKey}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </form>
                  <div className="d-flex justify-content-end mt-3">
                    <button
                      type="button"
                      class="btn btn-danger "
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <h3 className="mb-3 text-white">Vip Diamond Setting</h3>
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <form>
                      <div class="mb-3">
                        <label for="vipDiamond" class="form-label">
                          Vip Diamond Bonus ( get extra bonus coin when user
                          purchase vip plan )
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          id="vipDiamond"
                          placeholder={ `Enter Vip Diamond Bonus`   }
                          min="0"
                          value={vipDiamond}
                          onChange={(e) =>
                            setVipDiamond(parseInt(e.target.value))
                          }
                        />
                        {errors.vipDiamond && (
                          <div className="ml-2 mt-1">
                            {errors.vipDiamond && (
                              <div className="pl-1 text__left">
                                <span className="text-red">
                                  {errors.vipDiamond}
                                </span>
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      <div className="d-flex justify-content-end">
                        <button
                          type="button"
                          class="btn btn-danger "
                          onClick={handleSubmit}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <h3 className="mb-3 text-white">Email Setting</h3>
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <form>
                      <div class="mb-3">
                        <label for="resendApiKey" class="form-label">
                          Resend Api Key
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="resendApiKey"
                          placeholder={`Enter here resend API key`   }
                          value={resendApiKey}
                          onChange={(e) => setResendApiKey(e.target.value)}
                        />
                        {errors.resendApiKey && (
                          <div className="ml-2 mt-1">
                            {errors.resendApiKey && (
                              <div className="pl-1 text__left">
                                <span className="text-red">
                                  {errors.resendApiKey}
                                </span>
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      <div className="d-flex justify-content-end">
                        <button
                          type="button"
                          class="btn btn-danger "
                          onClick={handleSubmit}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { getSetting, updateSetting, handleSwitch })(
  Setting
);
